import React, { Fragment } from 'react'
import { Button, MenuButton } from '@arnsbogroup/react-voicearchive'
import MergeCustomerDialog from './components/MergeCustomerDialog'
import NiceModal from '@ebay/nice-modal-react'
import messages from './messages'
import { FormattedMessage } from 'react-intl'
import { Menu, Transition } from '@headlessui/react'

const Actions = ( {customer = {}} ) => {

  const mergeCustomer = () => {
    NiceModal.show(MergeCustomerDialog, {customer} )
  }

  return (
    <Menu as="div" className="relative ml-3">
      <Menu.Button>
        <Button variant="outline" size="sm" icon={['fal', 'ellipsis-vertical']} iconPosition="right">
          <FormattedMessage {...messages.actionsLabel} />
        </Button>
      </Menu.Button>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-10 mt-2 -mr-1 w-40 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <Menu.Item disabled>
            {(props) => (
              <MenuButton {...props} disabled className="cursor-help">
                Danger zone
              </MenuButton>
            )}
          </Menu.Item>

          <Menu.Item>
            {(props) => (
              <MenuButton size="sm" state="negative" {...props} onClick={mergeCustomer}>
                <FormattedMessage {...messages.mergeCustomer} />
              </MenuButton>
            )}
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}

export default Actions